import { AiTwotoneHome, AiOutlineMessage } from "react-icons/ai";
import { BiUserCircle } from "react-icons/bi";
import { BsBriefcase, BsCodeSlash } from "react-icons/bs";
import { MdWorkOutline } from "react-icons/md";
import { useScrollSpy } from "../../hooks/useScrollSpy";
import "./Nav.css";

const SECTION_IDS = ["#top", "#work", "#about", "#career", "#skills", "#contact"];

const NAV_ITEMS = [
  { href: "#top", icon: AiTwotoneHome, label: "Home" },
  { href: "#work", icon: MdWorkOutline, label: "Work" },
  { href: "#about", icon: BiUserCircle, label: "About" },
  { href: "#career", icon: BsBriefcase, label: "Career" },
  { href: "#skills", icon: BsCodeSlash, label: "Skills" },
  { href: "#contact", icon: AiOutlineMessage, label: "Contact" },
];

export default function Nav() {
  const activeNav = useScrollSpy(SECTION_IDS);

  return (
    <nav aria-label="Main">
      {NAV_ITEMS.map(({ href, icon: Icon, label }) => (
        <a
          key={href}
          href={href}
          className={activeNav === href ? "active" : ""}
          aria-current={activeNav === href ? "page" : undefined}
          aria-label={label}
          title={label}
        >
          <Icon />
        </a>
      ))}
    </nav>
  );
}
